var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandboxBangCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 0.333374C3.82001 0.333374 0.833344 3.32004 0.833344 7.00004C0.833344 10.68 3.82001 13.6667 7.50001 13.6667C11.18 13.6667 14.1667 10.68 14.1667 7.00004C14.1667 3.32004 11.18 0.333374 7.50001 0.333374ZM8.16668 10.3334H6.83334V9.00004H8.16668V10.3334ZM8.16668 7.66671H6.83334V3.66671H8.16668V7.66671Z",
    fill: "#003E66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandboxBangCircle);
export default __webpack_public_path__ + "static/media/sandbox-bang-circle.c4b5cae1ab592dfbeaf7b9c7680f3aed.svg";
export { ForwardRef as ReactComponent };